import { LitElement, html, css } from 'lit'

export class CartCount extends LitElement {
  static styles = [
    css`
      .cart_count {
        display: flex;
        color: #fff;
        background-color: #1e262a;
        border-radius: 9999px;
        justify-content: center;
        align-items: center;
        width: 14px;
        height: 14px;
        font-size: 10px;
        line-height: 14px;
        top: -4px;
        right: -9px;
        position: absolute;
      }
    `,
  ]

  static properties = {
    count: { type: Number },
    hideWhenZero: { type: Boolean, attribute: 'hide-when-zero' },
  }

  constructor() {
    super()

    window.MicroBus.on('count-change', (e) => {
      this.count = e.detail.count
    })
  }

  render() {
    return this.hideWhenZero && this.count === 0 ? html`` : html`<div class="cart_count">${this.count}</div>`
  }
}

customElements.define('cart-count', CartCount)
